import React from 'react';
import { SectionInstance } from '../types';
import InlineEditText from '../InlineEditText';
import { sfCtaText, sfCtaUrl, sfHeadline, sfSub } from './sectionHelpers';

const HeroMinimal: React.FC<{ section: SectionInstance }> = ({ section }) => {
  const c = section.controls;
  return (
    <header style={{ padding: '120px 24px', textAlign: 'center' }}>
      <div style={{ maxWidth: 800, margin: '0 auto' }}>
        <InlineEditText
          tag="h1"
          controlKey="headline"
          style={{ fontSize: '3.75rem', lineHeight: 1.1, marginBottom: 16, letterSpacing: '-0.025em', fontWeight: 800 }}
        >
          {sfHeadline(c, 'Your Headline')}
        </InlineEditText>
        <InlineEditText
          tag="p"
          controlKey="subheadline"
          style={{ fontSize: '1.125rem', color: 'var(--brand-text-light, #64748b)', marginBottom: 32 }}
        >
          {sfSub(c, 'Your supporting subheadline text goes here')}
        </InlineEditText>
        {sfCtaText(c) !== undefined || true ? (
          <a
            href={sfCtaUrl(c)}
            className="sb-cta-btn"
            style={{
              display: 'inline-block', padding: '14px 32px', borderRadius: 6,
              background: 'var(--brand-primary, #1a365d)', color: '#fff',
              fontWeight: 600, textDecoration: 'none',
              boxShadow: '0 4px 14px rgba(0,0,0,0.15)', transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
            }}
          >
            {sfCtaText(c, 'Get Started')}
          </a>
        ) : null}
      </div>
    </header>
  );
};

export default HeroMinimal;
